import { render, staticRenderFns } from "./SharePortfolio.vue?vue&type=template&id=14814f16&scoped=true&"
import script from "./SharePortfolio.vue?vue&type=script&lang=js&"
export * from "./SharePortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14814f16",
  null
  
)

export default component.exports